import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';

const ModalCard = styled(Box)(({ theme }) => ({
  background: 'white',
  fontFamily: 'Roboto, sans-serif',
  padding: '30px',
  maxWidth: '350px',
  width: '90%',
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'justify',
  borderRadius: '5px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    padding: '20px',
    maxWidth: '90%',
    boxShadow: 'none',
  },
  [theme.breakpoints.down('xs')]: {
    padding: '15px',
    width: '95%',
  },
}));

const PasswordExpireHead = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: 0,
  borderBottom: '1px solid #A8A8A8',
});

const CloseButton = styled('div')({
  cursor: 'pointer',
  color: '#A8A8A8',
  fontWeight: '700',
  marginLeft: '4%',
  fontSize: '18px',
});

const BtnWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '10px',
});

const SessionTimeoutModal = ({ classes, stayLoggedIn }) => {
  const [timer, setTimer] = useState(60);
  const history = useHistory();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimer(seconds => seconds - 1);
    }, 1000);

    if (timer === 0) {
      clearInterval(intervalId);
      history.push('/logout');
    }

    return () => clearInterval(intervalId);
  }, [timer, history]);

  const logOff = () => {
    history.push('/logout');
  };

  return (
    <ModalCard sx={classes?.card}>
      <PasswordExpireHead>
        <Typography variant="h5" component="h2">
          Session Timeout
        </Typography>
        <CloseButton
          role="button"
          tabIndex={0}
          onClick={stayLoggedIn}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              stayLoggedIn();
            }
          }}
        >
          x
        </CloseButton>
      </PasswordExpireHead>
      <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
        You&#39;re being timed out due to inactivity. Please choose to stay signed in or to log off.
        Otherwise, you&#39;ll be logged out automatically.
      </Typography>
      <BtnWrapper>
        <Button onClick={logOff} variant="outlined">
          Log Off
        </Button>
        <Button onClick={stayLoggedIn} variant="contained" color="primary">
          Stay Logged In({timer})
        </Button>
      </BtnWrapper>
    </ModalCard>
  );
};

SessionTimeoutModal.propTypes = {
  classes: PropTypes.shape({
    card: PropTypes.object,
  }),
  stayLoggedIn: PropTypes.func.isRequired,
};

SessionTimeoutModal.defaultProps = {
  classes: {},
};

export default SessionTimeoutModal;
